import NewsPreferencesForm, {
  PREFERENCES_GRID_SX,
} from '../../components/Profile/NewsPreferencesForm';
import { getUserNewsPreferences } from '../../features/queries/getUserNewsPreferences';
import { useQ } from '../../lib/query';
import { __, toastError } from '../../utils';
import SectionFooter from './SectionFooter';
import { Box, Skeleton, Stack } from '@presov.sk/presov-ui-react';
import React from 'react';

const NewsPreferences: React.FC = () => {
  const {
    data: preferences,
    isLoading,
    isError,
    refetch,
  } = useQ(getUserNewsPreferences);

  React.useEffect(() => {
    return () => {
      refetch();
    };
  }, [refetch]);

  React.useEffect(() => {
    if (isError) {
      toastError(__('Chyba pri načítaní preferencií používateľa'));
    }
  }, [isError]);

  return (
    <Stack gap={1} height={'100%'}>
      {/* `flex: 1` a nie `height: 100%`: pod zoznamom stojí pätička sekcie,
          takže plná výška by ju vytlačila za spodnú hranu karty. */}
      <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        {isLoading || !preferences ? (
          <Stack gap={1.5}>
            <Skeleton variant='text' width='60%' />
            <Box sx={PREFERENCES_GRID_SX}>
              {Array.from({ length: 7 }, (_, i) => (
                <Skeleton key={i} variant='rounded' height={72} />
              ))}
            </Box>
          </Stack>
        ) : (
          <NewsPreferencesForm preferences={preferences} />
        )}
      </Box>

      <SectionFooter
        hint={__('Vypnuté kategórie sa nezobrazia ani v prehľade na Domov.')}
      />
    </Stack>
  );
};

export default NewsPreferences;
